import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateDatabase } from "../../models/databases/CreateDatabase";
import { UpdateDatabase } from '../../models/databases/UpdateDatabse';

const RESOURCE_NAME = 'database';

const getAll = () => {
    const http = getAxiosInstance();
    return http.get(`${RESOURCE_NAME}/getAll`, requestConfig());
  };

const create = (model: CreateDatabase) => {
    const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/create`, model, requestConfig());
};

const update = (model: UpdateDatabase) => {
    const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/update/${model.id}`, model, requestConfig());
};

const remove = (id: number) => {
    const http = getAxiosInstance();
    return http.delete(`${RESOURCE_NAME}/delete/${id}`, requestConfig());
  }

const DatabaseService = {
  getAll,
  create,
  update,
  remove,
};
export default DatabaseService;